import { C1Icon } from 'components/core/icons/C1Icon'
import { styles } from 'components/core/task/outcome/styles'
import { sxc } from 'components/no-ui/styles/styleTypes'
import { Ban, CircleAlert, CircleCheck, Hourglass, XCircle } from 'lucide-react'
import { CertifyOutcome, GrantOutcome, RevokeOutcome } from 'pbts/c1/api/task/v1/task'
import React from 'react'

export const OutcomeIcon = ({
    outcome,
    applyStyles = false,
}: {
    outcome: CertifyOutcome | GrantOutcome | RevokeOutcome
    applyStyles?: boolean
}): React.ReactElement => {
    switch (outcome) {
        case CertifyOutcome.CERTIFIED:
        case GrantOutcome.GRANTED:
        case RevokeOutcome.REVOKED:
            return (
                <C1Icon
                    icon={CircleCheck}
                    sx={sxc(
                        { display: 'block' },
                        [applyStyles, styles.outcomeIcon],
                        styles.approved,
                    )}
                />
            )
        case CertifyOutcome.DECERTIFIED:
        case GrantOutcome.DENIED:
        case RevokeOutcome.DENIED:
            return (
                <C1Icon
                    icon={Ban}
                    sx={sxc(
                        { display: 'block' },
                        [applyStyles, styles.outcomeIcon],
                        styles.denied,
                    )}
                />
            )
        case CertifyOutcome.ERROR:
        case GrantOutcome.ERROR:
        case RevokeOutcome.ERROR:
            return (
                <C1Icon
                    icon={CircleAlert}
                    aria-label="error"
                    sx={sxc(
                        [applyStyles, styles.outcomeIcon],
                        styles.error,
                    )}
                />
            )
        case CertifyOutcome.CANCELLED:
        case GrantOutcome.CANCELLED:
        case RevokeOutcome.CANCELLED:
            return (
                <C1Icon
                    icon={XCircle}
                    aria-label="error"
                    sx={sxc(
                        [applyStyles, styles.outcomeIcon],
                        styles.cancelled,
                    )}
                />
            )
        case CertifyOutcome.UNSPECIFIED:
        case GrantOutcome.UNSPECIFIED:
        case RevokeOutcome.UNSPECIFIED:
        default:
            return (
                <C1Icon
                    icon={Hourglass}
                    aria-label="pending"
                    sx={sxc(
                        [applyStyles, styles.outcomeIcon],
                        [applyStyles, styles.pending],
                    )}
                />
            )
    }
}
